import React from 'react';

import {TunnelStatus} from '@utils/tableHelpers';

export const buildSelectOptions = (dropdownData) => {
    return dropdownData.map(item => {
        return {id: item.id, key: item.id, value: item.id, text: `${item.name} (${item.id_string ?? item.url})`};
    });
};

export const buildTunnelSelectOptions = (dropdownData) => {
    return dropdownData.map(item => {
        const vtdTunnel = item.vtd_tunnel || {};
        const isStarted = !!vtdTunnel.started;

        return {
            id: item.id,
            key: item.id,
            value: item.id,
            text:
                <span>
                    {`${item.name} - ${vtdTunnel.name} (${vtdTunnel.id})`}
                    <span className='tunnel-status-label'>
                        <TunnelStatus isStarted={isStarted} />
                    </span>
                </span>,
        };
    });
};
